import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';

/* Modified มาจาก
SelectProvince.js 
*/

export default function Asynchronous(props) {
  const [open, setOpen] = React.useState(false);
  const [options, setOptions] = React.useState([]);
  const loading = open && options.length === 0;
  const { rhf, control, name, label } = props;

  //ทำงานเมื่อคลิกไปที่ช่อง
  React.useEffect(() => {
    let active = true;

    if (!loading) {
      return undefined;
    }

    (async () => {
      console.log('---call API Employment-rate---');

      var config = {
        method: 'get',
        url: '/api/cis/employment-rate',
      };

      axios(config)
        .then(function (response) {
          console.log("SelectEmploymentRate.js -------->", response)
          setOptions([...response.data]);
        })
        .catch(function (error) {
          console.log(error);
        });
    })();

    return () => {
      active = false;
    };
  }, [loading]);

  React.useEffect(() => {
    if (!open) {
      setOptions([]);
    }
  }, [open]);

  return (
    <rhf.Controller
      render={({ field, fieldState: { error }, value }) => (
        <Autocomplete
          {...field}
          id="emp-rate-select"
          options={options}
          open={open}
          onOpen={() => {
            setOpen(true);
          }}
          onClose={() => {
            setOpen(false);
          }}
          getOptionLabel={(option) => option.name || ''}
          //Fix MUI: The value provided to Autocomplete is invalid. None of the options match with...
          isOptionEqualToValue={(option, value) => {
            return option.id === value.id;
          }}
          onChange={(_, data) => field.onChange(data)}
          loading={loading}
          //https://stackoverflow.com/questions/69395945/how-can-i-add-unique-keys-to-react-mui-autocomplete-component
          //แก้ปัญหา Warning: Encountered two children with the same key. Keys should be unique so that components maintain their identity across updates
          renderOption={(props, option) => {
            return (
              <li {...props} key={option.id}>
                {option.name}
              </li>
            );
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              label={label || 'การใช้อัตรา'}
              variant="filled"
              fullWidth
              error={!!error}
              helperText={error ? error.message : null}
              InputProps={{
                ...params.InputProps,
                endAdornment: (
                  <React.Fragment>
                    {loading ? (
                      <CircularProgress color="inherit" size={20} />
                    ) : null}
                    {params.InputProps.endAdornment}
                  </React.Fragment>
                ),
              }}
            />
          )}
        />
      )}
      name={name}
      control={control}
    />
  );
}
